"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWalletName = exports.WalletImportMethod = exports.SyncWalletLimitType = exports.SyncWalletAuthErrorReason = exports.SyncWalletErrorDetailCode = exports.FileImportState = exports.SyncState = void 0;
var SyncState;
(function (SyncState) {
    SyncState["InProgress"] = "InProgress";
    SyncState["Error"] = "Error";
    SyncState["Init"] = "Init";
})(SyncState = exports.SyncState || (exports.SyncState = {}));
var FileImportState;
(function (FileImportState) {
    FileImportState["InProgress"] = "InProgress";
    FileImportState["Error"] = "Error";
    FileImportState["Init"] = "Init";
})(FileImportState = exports.FileImportState || (exports.FileImportState = {}));
var SyncWalletErrorDetailCode;
(function (SyncWalletErrorDetailCode) {
    /**
     * The provided API keys are not able to be used, e.g. invalid, expired etc.
     */
    SyncWalletErrorDetailCode["INVALID_AUTH"] = "INVALID_AUTH";
    /**
     * The API rate limit of the external API was exceeded.
     */
    SyncWalletErrorDetailCode["RATE_LIMIT"] = "RATE_LIMIT";
    SyncWalletErrorDetailCode["CUSTOM"] = "CUSTOM";
    /**
     * The blockchain address is invalid.
     */
    SyncWalletErrorDetailCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    /**
     * Interaction with the external API caused an unknown failure. We call it
     * an 'Outage' but it's most likely our programming error.
     */
    SyncWalletErrorDetailCode["OUTAGE"] = "OUTAGE";
    /**
     * The total number of transactions being synced would have exceeded one of
     * the limits in Syla.
     */
    SyncWalletErrorDetailCode["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    SyncWalletErrorDetailCode["UNKNOWN"] = "UNKNOWN";
})(SyncWalletErrorDetailCode = exports.SyncWalletErrorDetailCode || (exports.SyncWalletErrorDetailCode = {}));
var SyncWalletAuthErrorReason;
(function (SyncWalletAuthErrorReason) {
    SyncWalletAuthErrorReason["InvalidKey"] = "InvalidKey";
    SyncWalletAuthErrorReason["InsufficientPermission"] = "InsufficientPermission";
    SyncWalletAuthErrorReason["ExcessivePermission"] = "ExcessivePermission";
    SyncWalletAuthErrorReason["Expired"] = "Expired";
    SyncWalletAuthErrorReason["InvalidIpRestriction"] = "InvalidIpRestriction";
    SyncWalletAuthErrorReason["ValidKeyNotUsable"] = "ValidKeyNotUsable";
})(SyncWalletAuthErrorReason = exports.SyncWalletAuthErrorReason || (exports.SyncWalletAuthErrorReason = {}));
var SyncWalletLimitType;
(function (SyncWalletLimitType) {
    SyncWalletLimitType["RECORD"] = "RECORD";
    SyncWalletLimitType["TRANSACTION"] = "TRANSACTION";
    SyncWalletLimitType["DATA_SOURCE"] = "DATA_SOURCE";
})(SyncWalletLimitType = exports.SyncWalletLimitType || (exports.SyncWalletLimitType = {}));
var WalletImportMethod;
(function (WalletImportMethod) {
    WalletImportMethod["API"] = "API";
    WalletImportMethod["CSV"] = "CSV";
})(WalletImportMethod = exports.WalletImportMethod || (exports.WalletImportMethod = {}));
function getWalletName({ wallet, dataSource, }) {
    return (wallet === null || wallet === void 0 ? void 0 : wallet.customName) || dataSource.name;
}
exports.getWalletName = getWalletName;
